export enum AnswerModeEnum {
  ANSWERED = 'answered',
  SKIPPED = 'skipped',
  TIMEOUT = 'timeout',
}

export enum AnswerHintUsedEnum {
  STRONG = 'strong',
  VAGUE = 'vague',
}

export interface Score {
  correct_answer: string | string[] | string[][] | number | boolean;
  rubric_type: 'binary' | 'partial_credit';
  /** binary: 0 or 1 — partial_credit: 0..1 (fraction of marks earned) */
  value: number;
}

export interface SubmissionDetails {
  submission_details: {
    correct_answer?: Score['correct_answer'];
    score?: Pick<Score, 'rubric_type' | 'value'>;
    session_accuracy?: number;
    time_taken_seconds?: number;
    answer_mode?: AnswerModeEnum;
    hint_used?: AnswerHintUsedEnum;
  };
}
